import axios, { AxiosError, AxiosInstance } from "axios";
import type { AccessToken, AxiosSingletonConfig } from "./types";
import { removeCookie, setCookie } from "typescript-cookie";
import createAuthRefreshInterceptor from "axios-auth-refresh";

export class AxiosSingletonInstance{
    private static instance:  AxiosInstance;
    private constructor() {}

    public static getInstance ({
        refreshTokenUrl = '',
        cookieName = '',
        jwtName = '',
    }: AxiosSingletonConfig): AxiosInstance{
        if (!AxiosSingletonInstance.instance) {
            AxiosSingletonInstance.instance = axios.create({
                withCredentials: true,
            });

            const refreshAuth = async (req: AxiosError) => {
                try {
                    const {data} = await axios.get<AccessToken>(refreshTokenUrl, {
                        withCredentials: true
                    });
                    setCookie(cookieName, data.accessToken);

                    if (req.response) {
                        req.response.config.headers.Authorization = `Bearer ${data.accessToken}`;
                    }
                    return await Promise.resolve();
                } catch (error) {
                    removeCookie(cookieName)
                    removeCookie(jwtName);
                    window.location.href = '/';
                    return await Promise.reject(error);
                }
            };

            createAuthRefreshInterceptor(AxiosSingletonInstance.instance, refreshAuth, {
                statusCodes: [401],
            });
        }
        return AxiosSingletonInstance.instance;
    }
}
